module.exports = __webpack_public_path__ + "assets/img/thumb-Logitech-Influencer-Video.0be6b18a.webp";